<div class="flex flex-col h-screen relative">
  <app-header [doctorName]="doctorName"></app-header>
  <div class="flex flex-1 overflow-hidden">
    <!-- Side Navigation (Desktop/Tablet) -->
    <aside class="hidden w-64 bg-white p-4 overflow-y-auto md:block dark:bg-gray-800 dark:text-white">
      <app-navigation></app-navigation>
    </aside>

    <main
      class="flex-1 overflow-y-auto bg-gray-100 mb-6 md:mb-0 md:pb-0 dark:bg-gray-900 dark:text-gray-200 bg-[url('assets/images/subtle-prism.svg')] dark:bg-[url('assets/images/subtle-prism-dark.svg')] bg-cover bg-no-repeat bg-center">
      <div class="h-full max-w-screen-xl mx-auto">
        <!-- Main content area where routed components will be displayed -->
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <div
    class="md:hidden bg-white text-gray-900 dark:bg-gray-800 dark:text-white p-2 shadow-lg fixed bottom-0 left-0 w-full z-10">
    <app-navigation [isMobileNav]="true"></app-navigation>
  </div>
</div>
<!-- <app-footer></app-footer> -->